/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-10-22 14:59:16
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-10-30 15:34:05
 * @FilePath: \cei-saas-platform\src\store\modules\readChatStatus.js
 * @Description:获取聊天页面状态 显示小红点
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

import { chetRemind } from '@/api/customerList'

const state = {
	readChatStatus: 0, // 0 未读 1 已读
	webhookData: null
}
const mutations = {
	SET_READCHATSTATUS: (state, data) => {
		state.readChatStatus = data
	},
	SET_WEBHOOKDATA: (state, data) => {
		state.webhookData = data
	}
}
const actions = {
	// 获取未读推送记录状态
	getReadChatStatus({ commit }) {
		return new Promise((resolve, reject) => {
			chetRemind().then((response) => {
				if (response.status == 200000) {
					// console.log('xxxxxxxx', response.data)
					commit('SET_READCHATSTATUS', response.data.status)
					return resolve(response.data)
				} else {
					return reject(response.message)
				}
			})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
